var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FeaturingGrid"},[_c('div',{staticClass:"row"},[_c('div',{class:`featured-col col-lg-${_vm.featuredColSize} d-flex flex-column`},[_vm._t("featured")],2),_vm._v(" "),_c('div',{class:`col-lg-${_vm.rightColSize}`},[_c('slot-wrapper',{staticClass:"side-row row",attrs:{"wrapper-class":[
          'side-col d-flex flex-column',
          `col-lg-${12/_vm.rightColDivisions}`,
          _vm.rightColBorders
        ]}},[_vm._t("side")],2)],1)]),_vm._v(" "),_c('slot-wrapper',{staticClass:"row d-none d-lg-flex",attrs:{"wrapper-class":"col-sm-6 col-lg-3 pt-3 d-flex flex-column"}},[_vm._t("others")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }